/**
 * adds event handlers to change the mouse cursor when interactive map layers are hovered
 */
export default {
    methods: {
        /**
         * Add cursor change handlers to each layer
         *
         * @param {mapboxgl.Map} map - Mapbox GL map object
         * @param {Array} layerIds - layer id strings
         * @param {string} [cursor='pointer'] - cursor style to use on hover
         */
        addCursorChanger(map, layerIds, cursor = 'pointer') {
            // change styles on the map canvas
            const canvas = map.getCanvas();

            layerIds.forEach((layerId) => {
                map.on('mouseenter', layerId, () => {
                    canvas.style.cursor = cursor;
                });

                map.on('mouseleave', layerId, () => {
                    canvas.style.cursor = '';
                });
            });
        },
    },
};
